import { Component } from '@angular/core';

@Component({
  selector: 'hf-midas-failed-badge',
  templateUrl: './midas-failed-badge.component.html',
  styleUrls: ['./midas-failed-badge.component.scss']
})
export class MidasFailedBadgeComponent {}
